/**
 * Superficie Shell — infra layer (audit, externalServiceRepo, connectivity,
 * navigation, support).
 *
 * ATENCIÓN: este barrel incluye `./externalServiceRepo`, que importa
 * `sync/core/submitCommand` y dispara la cadena sync → commandDispatch →
 * commissions → team → session → shell. Por eso los consumidores que sólo
 * necesitan sesión o feature-flags deben importar desde `./session-api` o
 * `./feature-flags-api` y NO desde acá.
 *
 * Named exports only (no `export *`).
 */

export type { AuditLogRow, ListAuditLogsPageOptions } from './audit/auditLogs';
export {
  logBusinessAuditEvent,
  listAuditLogsPage,
  countAuditLogs,
  listTeamAuditLogsPage,
  countTeamAuditLogs,
} from './audit/auditLogs';

export { formatAuditEventLabel } from './audit/auditLogPresentation';

export type {
  ExternalServiceOperationRow,
  ExternalServicePaymentMethod,
  ExternalServiceType,
} from './externalServiceRepo';
export {
  getExternalServiceOperations,
  insertExternalServiceOperation,
} from './externalServiceRepo';

export { isOnline, getConnectivityStatus, subscribeConnectivity } from './connectivity/connectivityInfra';
export type { ConnectivityStatus } from './connectivity/connectivityInfra';

export { useConnectivityStatus } from './connectivity/useConnectivityStatus';

export { navigateInShell, navigateRoot } from './navigation/rootNavigation';

export { useShellScreenHeaderRefresh } from './navigation/TabScreenRefreshContext';

export { cashManagementNavHint } from './navigation/cashNavigationHint';

export { useResetModuleUiOnBlur } from './navigation/useResetModuleUiOnBlur';

export { SupportUnreadBadge, SupportUnreadIconAnchor } from './support/components/SupportUnreadBadge';
export { withSupportUnreadAccessibilityLabel } from './support/components/supportUnreadPresentation';
